import React from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Image from '@tiptap/extension-image';
import TaskList from '@tiptap/extension-task-list';
import TaskItem from '@tiptap/extension-task-item';
import BlockItem from './BlockItem';
import './styles.scss';
import BlockDocument from './BlockDocument';
import { SlashCommand } from './SlashCommand';

const extensions = [
  StarterKit,
  Image,
  BlockItem,
  BlockDocument,
  SlashCommand,
  TaskList,
  TaskItem.configure({
    nested: true
  })
];

const content = {
  type: 'doc',
  content: [
    {
      type: 'blockItem',
      content: [{ type: 'paragraph', content: [{ type: 'text', text: '' }] }]
    }
  ]
};

const Tiptap = () => {
  const editor = useEditor({
    extensions,
    content
  });

  return <EditorContent editor={editor} />;
};

export default Tiptap;
